import { render, staticRenderFns } from "./ManualOrderFulfillment.vue?vue&type=template&id=2fc33eee&scoped=true"
import script from "./ManualOrderFulfillment.vue?vue&type=script&lang=js"
export * from "./ManualOrderFulfillment.vue?vue&type=script&lang=js"
import style0 from "./ManualOrderFulfillment.vue?vue&type=style&index=0&id=2fc33eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc33eee",
  null
  
)

export default component.exports